import {
  UserInfoFlow,
  UserInfoFlowStep,
  UserInfoFlowSteps,
  UserInfoFlowStepStatus,
} from '../../types/User/UserInfoFlow'

export const getStepStatus = (
  index: number,
  userInfoFlow: UserInfoFlow | null,
  steps: UserInfoFlowStep[],
  ffMigrateToPasskey?: boolean,
): UserInfoFlowStepStatus => {
  if (!userInfoFlow) return UserInfoFlowStepStatus.PENDING

  const isStepCompleted = (key: UserInfoFlowSteps): boolean => {
    switch (key) {
      case UserInfoFlowSteps.WALLET:
        return ffMigrateToPasskey
          ? userInfoFlow.wallet.hasWallet && !userInfoFlow.wallet.isWalletless
          : userInfoFlow.wallet.hasWallet
      case UserInfoFlowSteps.KYC:
        return userInfoFlow.kyc
      case UserInfoFlowSteps.BILLING_ADDRESS:
        return userInfoFlow.billingAddress
      case UserInfoFlowSteps.USER_INFO:
        return userInfoFlow.userInfo
      default:
        return false
    }
  }

  const allPreviousStepsCompleted = steps
    .slice(0, index)
    .every((step) => isStepCompleted(step.key))

  //if (allPreviousStepsCompleted) {
  return isStepCompleted(steps[index].key)
    ? UserInfoFlowStepStatus.COMPLETED
    : UserInfoFlowStepStatus.CURRENT
  //}

  // return UserInfoFlowStepStatus.PENDING
}

export const isInfoFlowOver = (
  userInfoFlow: UserInfoFlow | null,
  requireWalletlessMigration?: boolean,
): boolean => {
  if (!userInfoFlow) {
    return false
  }

  if (requireWalletlessMigration) {
    return (
      userInfoFlow.userInfo &&
      userInfoFlow.billingAddress &&
      userInfoFlow.wallet.hasWallet &&
      !userInfoFlow.wallet.isWalletless &&
      userInfoFlow.kyc
    )
  }

  return (
    userInfoFlow.userInfo &&
    userInfoFlow.billingAddress &&
    userInfoFlow.wallet.hasWallet &&
    userInfoFlow.kyc
  )
}
